exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".temp[data-v-65bd742a]{background:red;padding:12px;margin-bottom:12px;color:#fff}.temp h2[data-v-65bd742a]{font-size:18px;font-weight:600}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-65bd742a","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Order.vue
// module id = 360
// module chunks = 0